import {
  PROFILE_DEFAULT_MESSAGE,
  PROFILE_FALLBACK_MESSAGES,
} from "entities/user";
import { getApiErrorMessage } from "shared/utils";
import type { ApiError } from "shared/utils";

// 409 email_taken возможен на обоих шагах: адрес могли занять, пока письмо
// с подтверждением ждало в почте.
const EMAIL_TAKEN_MESSAGE = "This email is already in use.";

const CHANGE_FALLBACK_MESSAGES: Record<number, string> = {
  ...PROFILE_FALLBACK_MESSAGES,
  400: "Enter a valid email address that differs from the current one.",
  409: EMAIL_TAKEN_MESSAGE,
  429: "Too many requests. Please wait a bit and try again.",
};

const CONFIRM_FALLBACK_MESSAGES: Record<number, string> = {
  ...PROFILE_FALLBACK_MESSAGES,
  400: "The confirmation link is invalid or has expired.",
  409: EMAIL_TAKEN_MESSAGE,
};

export const getChangeEmailError = (error: ApiError): string | null =>
  getApiErrorMessage(error, CHANGE_FALLBACK_MESSAGES, PROFILE_DEFAULT_MESSAGE);

export const getConfirmEmailChangeError = (error: ApiError): string | null =>
  getApiErrorMessage(error, CONFIRM_FALLBACK_MESSAGES, PROFILE_DEFAULT_MESSAGE);
